import { render, staticRenderFns } from "./Disclaimer.vue?vue&type=template&id=551d85ee&"
import script from "./Disclaimer.vue?vue&type=script&lang=js&"
export * from "./Disclaimer.vue?vue&type=script&lang=js&"
import style0 from "./Disclaimer.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports